var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedulemaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.143555,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#EAEAEA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10481_24073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 18.5H21V22.5L24 24.5L24.75 23.27L22.5 21.75V18.5ZM22 15L8 9V16L17 18L8 20V27L15.27 23.89C16.09 26.83 18.79 29 22 29C25.86 29 29 25.86 29 22C29 18.14 25.86 15 22 15ZM22 27C19.25 27 17.02 24.78 17 22.03V21.96C17.02 19.22 19.25 16.99 22 16.99C24.76 16.99 27 19.23 27 21.99C27 24.75 24.76 27 22 27Z",
    fill: "#787878"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10481_24073"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedulemaker);
export default __webpack_public_path__ + "static/media/schedulemaker.9187ddd73109993b4c280eb8380db950.svg";
export { ForwardRef as ReactComponent };